import { getTenantCompanyConfig } from "../services/backend/tenantConfigService";
import { session, StorageKeys } from "../utils/storage";

export const DEFAULT_TENANT_ID = "1"; //sack=1, dinar=2

let company = null;
let loadPromise = null;

const DEFAULT_CANAL_CONFIG = {
  destacados: { tipo: "masVendidos", limite: 5, codigos: "" },
  categorias: { tipo: "", limite: 5, subtitle: "revisa nuestras categorías", title: "Categorías" },
};

const DEFAULTS = {
  id: DEFAULT_TENANT_ID,
  logo: "",
  favicon: "",
  primaryColor: "#1A4692",
  whatsappUrl: "",
  contacts: [],
  catalogPdf: "",
  termsUrl: "",
  trackingUrl: "",
  youtubeVideo: "",
  login: {},
  topbar: {},
  footer: {},
  floatingWhatsapp: {},
  defaultWarehouse: "",
  defaultClientCode: "",
  defaultPriceListBase: "",
  defaultCanal: "",
  defaultContactId: null,
  defaultDocument: "",
  destacados: {
    B2B: { ...DEFAULT_CANAL_CONFIG.destacados },
    B2C: { ...DEFAULT_CANAL_CONFIG.destacados },
  },
  categorias: {
    B2B: { ...DEFAULT_CANAL_CONFIG.categorias },
    B2C: { ...DEFAULT_CANAL_CONFIG.categorias },
  },
};

const normalizeCanalConfig = (source, defaults) => {
  if (!source || typeof source !== "object" || Array.isArray(source)) return { ...defaults };
  return { ...defaults, ...source };
};

const normalizeMultiCanal = (source, defaults) => {
  if (!source || typeof source !== "object") return {};
  if (Array.isArray(source)) {
    const flat = source[0] || {};
    return {
      B2B: normalizeCanalConfig(flat, defaults),
      B2C: normalizeCanalConfig(flat, defaults),
    };
  }
  if (source.B2B || source.B2C) {
    return {
      B2B: normalizeCanalConfig(source.B2B, defaults),
      B2C: normalizeCanalConfig(source.B2C, defaults),
    };
  }
  return {
    B2B: normalizeCanalConfig(source, defaults),
    B2C: normalizeCanalConfig(source, defaults),
  };
};

export const normalizeCompany = (raw) => {
  const source = raw && typeof raw === "object" ? raw : {};
  const links = source.links && typeof source.links === "object" ? source.links : {};

  const merged = {
    ...DEFAULTS,
    ...source,
    destacados: normalizeMultiCanal(source.destacados, DEFAULTS.destacados.B2B),
    categorias: normalizeMultiCanal(source.categorias, DEFAULTS.categorias.B2B),
    links: undefined,
    termsUrl: source.termsUrl || links.termsUrl || DEFAULTS.termsUrl,
    trackingUrl: source.trackingUrl || links.trackingUrl || DEFAULTS.trackingUrl,
    catalogPdf: source.catalogPdf || links.catalogPdf || DEFAULTS.catalogPdf,
    youtubeVideo: source.youtubeVideo || links.youtubeVideo || DEFAULTS.youtubeVideo,
  };

  delete merged.links;

  return Object.freeze(merged);
};

export const loadCompanyConfig = (tenantId = DEFAULT_TENANT_ID) => {
  if (company) return Promise.resolve(company);
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    let raw = null;
    try {
      raw = await getTenantCompanyConfig(tenantId);
    } catch (err) {
      const cached = session.get(StorageKeys.COMPANY_FALLBACK);
      if (cached) {
        try {
          raw = JSON.parse(cached);
        } catch {
          raw = null;
        }
      }
      if (!raw) {
        loadPromise = null;
        throw err;
      }
    }
    const normalized = normalizeCompany(raw);
    company = normalized;
    try {
      session.set(StorageKeys.COMPANY_FALLBACK, JSON.stringify(raw));
    } catch {}
    return normalized;
  })();

  loadPromise.catch(() => {
    loadPromise = null;
  });

  return loadPromise;
};

export const getCompany = () => {
  if (!company) {
    throw new Error(
      "companyConfig: la configuración de compañía aún no ha sido cargada. " +
        "Asegúrate de que AppProviders haya resuelto loadCompanyConfig() antes de usar getCompany()."
    );
  }
  return company;
};

export const isCompanyLoaded = () => company !== null;

export const setCompanyForTesting = (raw) => {
  company = normalizeCompany(raw);
  loadPromise = Promise.resolve(company);
  return company;
};